export default function Logo(){
    return <img id="sighthound-logo" src="/redactor-logo-light.svg" alt="Sighthound Logo"/>
}